module.exports = __webpack_public_path__ + "static/img/word.d1216a40.png";